import {Component, NgZone} from '@angular/core';
import {
  AlertController,
  App,
  Events,
  IonicPage,
  ModalController,
  NavController,
  NavParams,
  Platform
} from 'ionic-angular';
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {CourseVideo} from "../../models/course-video";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {AppVideoQuizPage} from "../app-video-quiz/app-video-quiz";
import {AppVideoMyWayPage} from "../app-video-my-way/app-video-my-way";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {UserStatsProvider} from "../../providers/user-stats/user-stats";
import * as moment from "moment";
import {AppSettingsTrainingPopupPage} from "../app-settings-training-popup/app-settings-training-popup";
import {AppPopupEvaluationPage} from "../app-popup-evaluation/app-popup-evaluation";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ApiProvider} from "../../providers/api/api";
import {LocalStorageWrapper} from "../../providers/local-storage-wrapper/local-storage-wrapper";

/**
 * Generated class for the AppVideoPlayerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-video-player',
  templateUrl: 'app-video-player.html',
})
export class AppVideoPlayerPage {

  currentTime: number;
  openedQuestions: object = {};
  videoPlayer: any;
  playing: boolean;
  playerInitialized: boolean = false;
  backgroundLayerVisible: boolean = true;
  playerHeight: number;

  video: CourseVideo;
  currentVideo: boolean;

  showAnswers: boolean = false;
  showSources: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public progressProvider: UserProgressStateProvider,
    public alertCtrl: AlertController,
    public contentTranslation: ContentTranslationProvider,
    public stats: UserStatsProvider,
    public app: App,
    public events: Events,
    public modalCtrl: ModalController,
    public platform: Platform,
    public userState: UserStateProvider,
    public api: ApiProvider,
    public localStorage: LocalStorageWrapper,
    public ngZone: NgZone
  ) {
    if(!this.navParams.data) {
      this.navCtrl.push(AppDashboardPage)
    }
    this.video = (this.navParams.data as CourseVideo);
    this.currentVideo = (this.video._userStatus == 2);

    this.playerHeight = Math.round(document.body.clientWidth / 1.77);
    if(this.platform.is('android')) {
      this.backgroundLayerVisible = false;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppVideoPlayerPage');
    this.endHandlerStarted = false;
  }

  ionViewDidEnter() {
    this.playerHeight = Math.round(document.body.clientWidth / 1.77);

    var me = this;

    var options = {
      id: me.video.videoId,
      loop: false,
      playsinline: this.userState.user.playerIssues?true:false
    };

    var player = new (window as any).Vimeo.Player('video-player', options);
    this.videoPlayer = player;
    player.setVolume(1);

    player.on('loaded', e => {
      me.playerInitialized = true;
    });

    player.on('play', function(e) {
      console.log('played the video! '+e.percent, e);

      if(e.percent == 1) {
        me.endHandler();
      }
    });
    player.on('seeked', function(e) {
      console.log(e.seconds, me.currentTime);
      if(e.seconds > me.currentTime+1) {
        // player.setCurrentTime(me.currentTime);
      }
    });
    player.on('error', function(e) {
    });
    player.on('pause', function(e) {
      console.log('paused '+e.percent);
    });
    player.on('ended', (e) => {
      console.log('player ended', this);

      me.endHandler();
    });
    player.on('timeupdate', function(e) {
      if(e.seconds < me.currentTime || e.seconds > me.currentTime+2) {
        return ;
      }
      me.currentTime = e.seconds;
    });
  }

  endHandlerStarted = false;
  endHandler () {
    var me = this;

    if(this.endHandlerStarted) {
      return ;
    }
    this.endHandlerStarted = true;

    this.events.publish('video:watched', {
      "modulePosition": this.video.module?this.video.module.position:null,
      "videoPosition": this.video.position,
      "bonus": this.video.bonusVideo,
      "type": this.video.type,
    })

    setTimeout(() => {
      if(this.videoPlayer) {
        this.videoPlayer.unload().then();
      }
      me.playing = false;
    }, 500);

    let postVideoProcess = () => {
      // init video
      /*if(me.video.module && me.video.module.position == 0 && me.video.type != 'plus' && !this.userState.user.introWatched) {
        me.api.callPut('/users/'+this.userState.user.id, {introWatched: true}).subscribe(_resp => {
          this.userState.user.introWatched = true;
          me.video.module._userStatus = 3;
          me.video._userStatus = 3;
        })
      }*/

      if (me.progressProvider.currentProgress && me.progressProvider.currentProgress.video && me.progressProvider.currentProgress.video.id == me.video.id) {
        if(me.video.trainingVideo && !me.progressProvider.currentProgress.videoShown && me.video.module.position == 1) {
          let modal = me.modalCtrl.create(AppSettingsTrainingPopupPage, {}, {cssClass: 'modal-alert ip-alert ip-with-close ip-training-notifications-popup'});
          modal.present().then();
        }

        if(this.userState.user.insurance && this.userState.user.insurance.aokId && me.video.position == 0 && !me.progressProvider.currentProgress.videoShown && me.video.module.position == 2) {
          let modal = me.modalCtrl.create(AppPopupEvaluationPage, {}, {cssClass: 'modal-alert ip-alert ip-with-close ip-training-notifications-popup app-modal-popup'});
          modal.present().then();
        }
        if(this.userState.user.insurance && this.userState.user.insurance.aokId && me.video.position == 0 && !me.progressProvider.currentProgress.videoShown && me.video.module.position == 3) {
          let modal = me.modalCtrl.create(AppPopupEvaluationPage, {type: 'second'}, {cssClass: 'modal-alert ip-alert ip-with-close ip-training-notifications-popup app-modal-popup'});
          modal.present().then();
        }

        me.progressProvider.currentProgress.videoShown = true;
        me.progressProvider.currentProgress.video._userStatus = 3;
        if (me.video.type == 'none') {
          me.progressProvider.currentProgress.taskDone = true;
        }
        me.progressProvider.triggerProgressUpdate();
      }
      console.log('watched video', me.video);
      if (me.video.module && me.video.module.type == 'greeting') {
        if(me.video._userStatus != 3) {
          me.video._userStatus = 3;
          me.progressProvider.triggerVideoPlusUpdate(me.video, 3);
          me.video.module._userClosed++;
          this.events.publish('state:refreshed-locally');
        }
        me.navCtrl.pop();
      } else if (me.video.type == 'none') {
        if(me.video.trainingVideo) {
          me.navCtrl.pop();
        }
      } else if (me.video.type == 'quiz') {
        me.navCtrl.pop();
      } else if ((me.video.type == 'plus' && me.video.quizQuestions.length > 0)) {
        me.app.getRootNav().push(AppVideoQuizPage, me.video, null, () => {
          me.navCtrl.remove(me.navCtrl.getActive().index, 1);
        });
      } else if (me.video.type == 'my-way') {
        me.app.getRootNav().push(AppVideoMyWayPage, me.video, {animate: false}, () => {
          me.navCtrl.remove(me.navCtrl.getActive().index, 1);
        });
      } else if (me.video.type == 'plus') {
        me.video._userStatus = 3;
        me.progressProvider.triggerVideoPlusUpdate(me.video, 3)
        me.navCtrl.pop();
      }
    }

    if (me.video.trainingVideo) {
      let alertElement = me.alertCtrl.create({
        title: me.contentTranslation.translateContent('Did you do the training title'),
        message: me.contentTranslation.translateContent('Did you do the training content'),
        cssClass: 'ip-alert ip-alert-with-content ip-training-popup ip-with-close',
        buttons: [
          {
            text: me.contentTranslation.translateContent('Did you do the training Save'),
            handler: (data) => {
              if(data == '1') {
                if (me.progressProvider.currentProgress.videoId != me.video.id) {
                  me.events.publish('training:repeated');
                }
                me.stats.addActivity({date: moment().format('YYYY-MM-DD'), type: 3, length: 23}).then((statResponse) => {
                  me.events.publish('stats:updated', statResponse);
                });
              }
              postVideoProcess();
            },
            cssClass: 'save-button'
          },
          {
            text: '×',
            cssClass: 'close-button',
            handler: () => {
              postVideoProcess()
            }
          }
        ]
      });

      alertElement.addInput({
        type: 'radio',
        label: me.contentTranslation.translateContent('Ja, ich habe das Training absolviert'),
        value: '1',
      });

      alertElement.addInput({
        type: 'radio',
        label: me.contentTranslation.translateContent('Dieses Mal nicht, aber ich bleibe dran'),
        value: '0'
      });

      alertElement.present();
    } else {
      postVideoProcess();
    }
  }

  playVideo() {
    if(this.videoPlayer && this.backgroundLayerVisible) {
      this.videoPlayer.play();
      this.playing = true;
    }
  }

  goToChat() {
    this.navCtrl.parent.select(5);
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-video-player/app-video-player.ts